<template>
  <div class="hmt-carousel-container relative">
    <swiper 
      ref="swiper"
      :options="swiperOption"
      class="hmt-carousel"
      @slide-change="slideChange"
      @clickSlide="selectPhoto"
    >
      <swiper-slide
        class="group"
        v-for="photo in items"
        :key="photo.md"
      >
        <lazy-image
          :src="photo.md"
        />
        <div class="swiper-lazy-preloader swiper-lazy-preloader-black"></div>
      </swiper-slide>
    </swiper>
    <button 
      class="absolute top-1/2 -translate-y-1/2 left-5 z-10 w-[32px] hmt-carousel__nav-button--prev cursor-pointer [&:is(.swiper-button-disabled)]:cursor-not-allowed [&:is(.swiper-button-disabled)]:opacity-50"
    >
    <svg viewBox="0 0 40 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="1" width="38" height="70" stroke="white" stroke-width="2"/>
<path d="M19.9998 41.8334L14.1665 36.0001L19.9998 30.1667" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M25.8332 36H14.1665" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    </button>
    <button 
        class="absolute top-1/2 -translate-y-1/2 w-[32px] right-5 z-10 hmt-carousel__nav-button--next cursor-pointer"
    >
    <svg viewBox="0 0 40 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="1" width="38" height="70" stroke="white" stroke-width="2"/>
<path d="M14.1665 36H25.8332" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 30.1667L25.8333 36.0001L20 41.8334" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    </button>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Carousel',
    props: {
			items: {
				type: Array
			}
		},
    data() {
      return {
        swiperOption: {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerColumnFill: 'row',
          spaceBetween: 15,
          navigation: {
            nextEl: '.hmt-carousel__nav-button--next',
            prevEl: '.hmt-carousel__nav-button--prev',
          }
        }
      }
    },
    computed: {
      ...mapGetters('tour', ['getPrimaryColor'])
    },
    methods: {
      selectPhoto (photoIndex) {
        this.$emit('onSelectItem', photoIndex);
      },
      slideChange () {
        const activeIndex = this.$refs.swiper.$swiper.activeIndex;
        this.$emit('onSlideChange', activeIndex);
      }
    }
  };
</script>

<style lang="scss">
  .hmt-carousel {
    &-container {
      position: relative;
      max-width: 840px;
      margin: 0 auto;
    }

    .swiper-slide {
      $slide: &;

      position: relative;
      width: 420px;
      height: 500px;
      cursor: pointer;

      img {
        position: relative;
        z-index: 30;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
